<template>
  <div class="row">
    <div class="col-12">
        <card class="card-user" :headerClass="'text-center'" :title="trans.profile.title" :subTitle="trans.profile.des">
          <div slot="image">
            <!-- <img style="opacity: .8" src="@/assets/img/cover.png" alt="..."> -->
          </div>
          <div>
            <div class="author">
<!--              <img width="150px" height="150px" src="@/assets/img/faces/profile.jpg" alt="...">-->
              <button v-if="!data.isUpdateStart" @click.prevent="startUpdate" class="btn btn-outline-success"><i class="ti-pencil"></i></button>
              <button v-else @click.prevent="startUpdate" class="btn btn-outline-danger"><i class="ti-close"></i></button>
              <h4 class="title"> {{data.form.name}}
                <br>
                <a href="javascript:void(0)">

                </a>
                <small>@{{data.form.user_name}}</small>
              </h4>

            </div>
          </div>

          <div v-if="!data.isUpdateStart" class="p-2 table-responsive">
            <table class="table table-striped table-bordered mb-5">
              <thead>
              <tr class="text-center">
                <th colspan="8"><i class="fa fa-user"></i> {{trans.profile.des}}</th>
              </tr>
              </thead>
              <tbody>

              <tr>
                <th scope="col">{{trans.users.fields.name}}</th>
                <th scope="col">{{trans.users.fields.email}}</th>
                <th scope="col">{{trans.users.fields.password}}</th>
                <th scope="col">{{trans.users.fields.role}}</th>
                <th scope="col">{{trans.users.fields.username}}</th>
              </tr>

              <tr>
                <td>{{data.form.name}}</td>
                <td>{{data.form.email}}</td>
                <td>****</td>
                <td>{{data.form.role_name}}</td>
                <td>{{data.form.user_name}}</td>
              </tr>

              </tbody>
            </table>
          </div>
          <div v-if="data.isUpdateStart" class="p-2">
            <div class="row mb-3">
              <div class="col-md-6">
                <label>{{trans.users.fields.name}}</label>
                <input type="text" v-model="user.name" class="form-control" required>
                <div class="error-msg" v-if="data.errors.name">
                  <i class="fa fa-info-circle"></i>{{data.errors.name[0]}}
                </div>
              </div>

              <div class="col-md-6">
                <label>{{trans.users.fields.email}}</label>
                <input type="email" v-model="user.email" class="form-control" required>
                <div class="error-msg" v-if="data.errors.email">
                  <i class="fa fa-info-circle"></i>{{data.errors.email[0]}}
                </div>
              </div>

              <div class="col-md-6 mt-5">
                <label>{{trans.users.fields.username}}</label>
                <input type="text" v-model="user.user_name" class="form-control" required>
                <div class="error-msg" v-if="data.errors.user_name">
                  <i class="fa fa-info-circle"></i>{{data.errors.user_name[0]}}
                </div>
              </div>

              <div class="col-md-6 mt-5">
                <label>{{trans.users.fields.password}}</label>
                <input type="password" autocomplete="new-password" v-model="user.password" class="form-control" required>
                <div class="error-msg" v-if="data.errors.password">
                  <i class="fa fa-info-circle"></i>{{data.errors.password[0]}}
                </div>
              </div>

              <div class="col-md-4 mt-5">
                <update-button v-if="!data.isRequested" @doUpdate="update()"></update-button>
              </div>
            </div>
          </div>
          <hr>
      </card>
    </div>
  </div>
</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import store from '@/store'

export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      data: {
        trans: this.$root.trans,
        form: {},
        isRequested: false,
        isUpdateStart: false,
        errors: {},
        options: [],
      },
      user: {
        name : "",
        email : "",
        user_name : "",
        password : "",
        role : "",
        location_id : "",
        phone : "",
        mobile : "",
        status : "",
      },
    };
  },
  created() {
    this.findOne();
    this.getTree();
  },
  methods: {
    findOne(updateAction = false) {
      this.$baseApi.post('/me').then((response) => {
        if (response.data.code === 200 && response.data.data != null) {
          this.data.form = response.data.data;
          if (this.data.isUpdateStart) {
            this.user = {
              name : response.data.data.name,
              email : response.data.data.email,
              user_name : response.data.data.user_name,
              password : response.data.data.password,
              role : response.data.data.role,
              status : response.data.data.status,
            };
            store.dispatch('SET_AUTH_USER', this.user);
          }
        }
      });
    },
    selected(node, instanceId){
      this.data.form.location_id = node.id;
    },
    getTree(){
      this.$baseApi.get('/locations?tree=true' ).then((response)=>{
        if(response.data.code === 200){
          this.data.options = response.data.data;
        }
      });
    },
    startUpdate() {
      this.data.isUpdateStart = !this.data.isUpdateStart
      this.findOne();
    },
    update(){
      this.data.isRequested = true;
      this.$baseApi.patch('/users/' + this.data.form.id, this.user).then((response)=>{
        if(response.data.code === 200){
          this.sweetAlert(this.trans.messages.updated_success)
          this.data.isUpdateStart = false
          this.data.isRequested = false
          this.findOne();
        }
      }).catch((error)=> {
        this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
        this.data.isRequested = false;
      });
    },
  },
  computed: {
    trans() {
      return this.$store.getters.GET_TRANS;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  },
};
</script>
<style>
</style>
